"use client";
import { Dialog } from "@base-ui/react/dialog";
import { XIcon } from "lucide-react";
import type { OvulationResponse } from "../../_components/types";

interface ResultDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  result: OvulationResponse | null;
}

export const ResultDialog = ({
  open,
  onOpenChange,
  result,
}: ResultDialogProps) => {
  return (
    <Dialog.Root onOpenChange={onOpenChange} open={open}>
      <Dialog.Portal>
        <Dialog.Backdrop className="fixed inset-0 z-50 bg-black/40 backdrop-blur-sm transition-opacity" />
        <Dialog.Popup className="fixed top-1/2 left-1/2 z-50 flex w-[90vw] max-w-md -translate-x-1/2 -translate-y-1/2 flex-col rounded-3xl bg-white shadow-2xl outline-none overflow-hidden">
          <div className="flex items-center justify-between px-6 py-4">
            <Dialog.Title className="text-xl font-bold text-gray-900">
              Yumurtlama Günü Hesaplama
            </Dialog.Title>
            <Dialog.Close className="rounded-full p-2 text-gray-400 transition-colors hover:bg-gray-100 hover:text-gray-600">
              <XIcon className="size-5" />
            </Dialog.Close>
          </div>

          <div className="bg-linear-to-b from-pink-100 to-white flex justify-center py-8">
            <div className="flex flex-col items-center justify-center rounded-full bg-[#e06868] size-36 text-white">
              <span className="text-5xl font-bold leading-none">
                {result?.cycleLengthDays ?? "-"}
              </span>
              <span className="text-base mt-1">
                {result?.cycleLengthSuffix ?? "Gün"}
              </span>
            </div>
          </div>

          {result ? (
            <div className="px-6 pt-2 pb-4 flex flex-col gap-4">
              <p className="text-gray-700 text-sm leading-relaxed">
                Girdiğiniz verilere göre sikluslarınız yaklaşık{" "}
                <strong>
                  {result.cycleLengthDays} {result.cycleLengthSuffix}
                </strong>{" "}
                sürüyor. Bir sonraki adetiniz muhtemelen{" "}
                <strong>{result.nextPeriodDate}</strong> tarihinde başlayacak.
              </p>
              <p className="text-gray-700 text-sm leading-relaxed">
                Gebe kalmanız açısından şansınızın en yüksek olduğu günler:{" "}
                <strong>
                  {result.fertileWindowStartDate}-{result.fertileWindowEndDate}
                </strong>{" "}
                tarihleri arasındadır.
              </p>
              <hr className="border-gray-200" />
              <p className="text-xs text-gray-500 leading-relaxed">
                {result.warningText}
              </p>
            </div>
          ) : (
            <p className="px-6 py-4 text-sm text-gray-500">Sonuç bulunamadı.</p>
          )}

          <div className="px-6 pb-6">
            <Dialog.Close className="w-full rounded-full bg-[#3b82c4] py-4 text-base font-semibold text-white transition-colors hover:bg-[#2d6ea8]">
              Tekrar Hesapla
            </Dialog.Close>
          </div>
        </Dialog.Popup>
      </Dialog.Portal>
    </Dialog.Root>
  );
};
